import React from 'react';
import {validationRules} from "../components/forms/validationRules";
import {isNoU} from "../utils/DBUtils";

const valueChangeValidator = (Component) => {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                errors: [],
                currentValue: props.value
            };
        }

        componentDidMount() {
            if (this.props.validateInitialValue === true) {
                this.validateValue(this.state.currentValue, true);
            }
        }

        validateValue = (value, runValidation) => {
            let errors = [];
            if ( runValidation && runValidation === true && !isNoU(this.props.validationRules) ) {
              for (let rule of this.props.validationRules) {
                  if (isNoU(validationRules[rule.type])) {
                      continue;
                  }

                  if (!validationRules[rule.type](value, rule.params, this.props.formProxy)) {
                      errors.push(rule);
                  }
              }
            }

            this.setState({
                errors: errors,
                currentValue: value
            });

            if (errors.length === 0) {
                this.props.onValueChanged(value);
            } else if (this.props.onValidationError) {
                this.props.onValidationError(value, errors);
            }
        };

        render() {
            return <Component {...this.props}
                              value={this.state.currentValue}
                              errors={this.state.errors}
                              onValueChanged={this.validateValue}/>;
        };
    };
};

export default valueChangeValidator;



// WEBPACK FOOTER //
// ./public/hoc/valueChangeValidator.jsx